import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './core/auth/auth.guard';
import { myCompanyRedirectGuard } from './pages/mi-empresa/mi-empresa.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'vacantes',
    pathMatch: 'full'
  },
  {
    path: 'vacantes',
    loadChildren: () =>
      import('./pages/vacantes/vacantes.routes').then((m) => m.VACANTES_ROUTES)
  },
  {
    path: 'perfil',
    loadChildren: () =>
      import('./pages/perfil/perfil.routes').then((module) => module.PERFIL_ROUTES)
  },
  {
    path: 'mi-panel',
    canActivate: [authGuard, roleGuard('solicitante')],
    loadChildren: () =>
      import('./pages/mi-panel/mi-panel.routes').then(m => m.MI_PANEL_ROUTES)
  },
  {
    path: 'mis-empleos',
    canActivate: [authGuard, roleGuard('solicitante')],
    loadChildren: () =>
      import('./pages/mis-empleos/mis-empleos.routes').then(m => m.MIS_EMPLEOS_ROUTES)
  },
  {
    path: 'onboarding',
    canActivate: [authGuard, roleGuard('solicitante')],
    loadChildren: () =>
      import('./pages/onboarding/onboarding.routes').then(m => m.ONBOARDING_ROUTES)
  },
  {
    path: 'empresas',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/empresas/empresas.routes').then(m => m.EMPRESAS_ROUTES)
  },
  {
    path: 'empresa',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/empresa-perfil/empresa-perfil.routes').then(m => m.EMPRESA_PERFIL_ROUTES)
  },
  {
    path: 'mi-empresa',
    canActivate: [authGuard, roleGuard('socio'), myCompanyRedirectGuard],
    loadChildren: () =>
      import('./pages/mi-empresa/mi-empresa.routes').then(m => m.MI_EMPRESA_ROUTES)
  },
  {
    path: 'panel-socio',
    canActivate: [authGuard, roleGuard('socio')],
    loadChildren: () =>
      import('./pages/panel-socio/panel-socio.routes').then(m => m.PANEL_SOCIO_ROUTES)
  },
  {
    path: 'mis-vacantes',
    canActivate: [authGuard, roleGuard('socio')],
    loadChildren: () =>
      import('./pages/empresa-vacantes/empresa-vacantes.routes').then(m => m.EMPRESA_VACANTES_ROUTES)
  },
  {
    path: 'explorar-candidatos',
    canActivate: [authGuard, roleGuard('socio')],
    data: {
      roleRedirectTo: '/mi-panel',
      roleRedirectMessageKey: 'explorar_candidatos.access_denied'
    },
    loadChildren: () =>
      import('./pages/explorar-candidatos/explorar-candidatos.routes').then(m => m.EXPLORAR_CANDIDATOS_ROUTES)
  },
  {
    path: 'candidatos/:userId',
    canActivate: [authGuard, roleGuard('socio')],
    loadComponent: () =>
      import('./pages/perfil/components/perfil-page/perfil-page.component').then(m => m.PerfilPageComponent)
  },
  {
    path: 'mensaxeria',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/mensaxeria/mensaxeria.routes').then(m => m.MENSAXERIA_ROUTES)
  },
  {
    path: '**',
    redirectTo: 'vacantes'
  }
];

